import { AxiosRequestConfig } from 'axios';

function serializeQuery(req: AxiosRequestConfig) {
  if (!req.params) return '';

  // Probably server-side, just stringify the object
  if (typeof URLSearchParams === 'undefined') return JSON.stringify(req.params);

  let { params } = req;

  const isInstanceOfURLSearchParams = req.params instanceof URLSearchParams;

  // Convert to an instance of URLSearchParams so it get serialized the same way
  if (!isInstanceOfURLSearchParams) {
    params = new URLSearchParams();
    Object.keys(req.params).forEach(key => params.append(key, req.params[key]));
  }

  return `?${params.toString()}`;
}

export default serializeQuery;
